module.exports = __webpack_public_path__ + "img/IMG_2081.bafa8713.jpg";